module.exports = __webpack_public_path__ + "static/media/_MIC2717.image.7eb3f6d9.png";